import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=bb50ce10&"
import script from "./serviceDetails.vue?vue&type=script&lang=ts&"
export * from "./serviceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./serviceDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports